import { useState } from 'react';
import { useRouter } from 'next/router';

import { SubscriptionPackage } from '@bpm-web-app/supreme-api-sdk';
import { getDefaultLibrary } from './helpers';

const options = [
    {
        title: 'Open Format',
        id: SubscriptionPackage.LibraryEnum.Music,
        description: 'An Open Format subscription provides download access to top genres like hip hop, R&B, pop, dance, and more, plus DJ-ready exclusives, edits, and remixes.',
    },
    {
        title: 'Latino + Global',
        id: SubscriptionPackage.LibraryEnum.Latin,
        description: 'A Latino+Global gives you top Latin genres plus exclusive remixes and worldwide trending music from Africa, the Caribbean, Asia, and beyond.',
    },
];

export const featuresData = {
    supreme: {
        standard: ['Download DJ-Ready Tracks', 'Exclusive Edits', 'Exclusive DJ Tutorials', 'Create Your Own Playlists', 'Bulk Crate Download'],
        premium: ['Exclusive Remixes', 'Exclusive Playlists', 'Curated DJ Sets', 'Collaborative Playlists', 'Additional Benefits'],
        all: ['All Music Libraries', 'All Playlists', 'All Edits & Remixes', 'All of BPM Create', { label: '+ Free Ebook ($19.99 est. value)', included: true, is_extra: true }],
    },
    create: {
        standard: ['100 Credits Monthly', 'Access to 15 Drives', { label: 'Collaborative Drives', included: false }],
        premium: ['250 Credits Monthly', 'Access to 30 Drives', 'Collaborative Drives'],
        premiumplus: ['450 Credits Monthly', 'Access to 40 Drives', 'Collaborative Drives'],
    },
};

export const useLibraryData = () => {
    const { query } = useRouter();
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const [library, setLibrary] = useState<SubscriptionPackage.LibraryEnum>(getDefaultLibrary(options, query['library']));

    return {
        library,
        setLibrary,
        options,
        selected: options.find((o) => o.id === library),
    };
};
